import React from 'react';
type State = { hasError: boolean; message?: string };
export default class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false };
  static getDerivedStateFromError(err: any) {
    return { hasError: true, message: String(err?.message || err) };
  }
  componentDidCatch(err: any, info: any) {
    console.error('[ErrorBoundary]', err, info);
  }
  render() {
    if (this.state.hasError) return <div className="p-3 rounded border border-red-500 bg-red-50">
      <div className="font-semibold">Something went wrong.</div>
      <pre className="text-sm whitespace-pre-wrap">{this.state.message}</pre>
    </div>;
    return this.props.children;
  }
}